import React from "react";
import {Outlet} from "react-router-dom";
import HeaderComponent from "../components/HeaderComponent";
import LoadingBarComponent from "../components/LoadingBarComponent";
import User from "../backend/User";

const Layout = () => {

    React.useEffect(() => {
        if(window.location.pathname === (process.env.PUBLIC_URL + '/') || window.location.pathname === (process.env.PUBLIC_URL)) {
            if(User.isAuthenticated()) {
                window.location = process.env.PUBLIC_URL + User.getHomepage();
            } else {
                window.location = process.env.PUBLIC_URL + "/login";
            }
        }
    });

    return (
        <>
            <LoadingBarComponent/>
            <HeaderComponent/>
            <Outlet/>
        </>
    );
};

export default Layout;